import _typeof from '@babel/runtime-corejs3/helpers/typeof';
import _Array$isArray from '@babel/runtime-corejs3/core-js-stable/array/is-array';
import _flagsInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/flags';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import '../../_virtual/2afb95d42b5c41acd07b80d09fb3d0fbe435285e7a6e4ff9eaf29dcc42e1b6d1.cfe-internal.js';

'use strict';

// do not edit .js files directly - edit src/index.jst

var fastDeepEqual = function equal(a, b) {
  if (a === b) return true;
  if (a && b && _typeof(a) == 'object' && _typeof(b) == 'object') {
    if (a.constructor !== b.constructor) return false;
    var length, i, keys;
    if (_Array$isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;) if (!equal(a[i], b[i])) return false;
      return true;
    }
    if (a.constructor === RegExp) return a.source === b.source && _flagsInstanceProperty(a) === _flagsInstanceProperty(b);
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
    keys = _Object$keys(a);
    length = keys.length;
    if (length !== _Object$keys(b).length) return false;
    for (i = length; i-- !== 0;) if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    for (i = length; i-- !== 0;) {
      var key = keys[i];
      if (!equal(a[key], b[key])) return false;
    }
    return true;
  }

  // true if both NaN, false otherwise
  return a !== a && b !== b;
};

export { fastDeepEqual as default };
